var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.tradingProductGroupSummary !== null
    ? _c(
        "form-button-disabler",
        { staticClass: "flex flex-col h-full" },
        [
          _c("div", { staticClass: "grid grid-cols-1" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-span-3 flex border-b border-gray-500 px-3 pt-3",
              },
              [
                _c("div", { staticClass: "flex text-xl" }, [
                  _vm._v("Trading Product Group: "),
                  _c("div", { staticClass: "font-bold text-xl pl-2" }, [
                    _vm._v(_vm._s(_vm.tradingProductGroupSummary.groupName)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-grow" }),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "mdi mdi-close mdi-24px font-bold cursor-pointer relative",
                  on: {
                    click: function ($event) {
                      return _vm.cancelProp()
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "grid grid-cols-2 pl-3 py-2 gap-y-1" }, [
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("CUSIP")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.tradingProductGroupSummary.cusip)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("Trading Account")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.tradingProductGroupSummary.tradingAccount)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("Orig Bid Price")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.origBidPrice ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("Current Bid Price")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.currentBidPrice ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("Loan Term")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.loanTerm ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("WA Price")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.weightedAvgPrice ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("Interest Rate")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.interestRate ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("GWAC")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.gwac ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("NWAC")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.nwac ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("Maturity Date")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.maturityDate ?? "",
                        "MM/dd/yyyy"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("Allocated Balance")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.allocatedBalance ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("Accrued Interest")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.accruedInterest ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inline-text" }, [
                _c("label", [_vm._v("Total Proceeds")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.formatString(
                        _vm.tradingProductGroupSummary.totalProceeds ?? 0,
                        "n2"
                      )
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "border-t border-b border-gray-500 p-3 font-bold text-xl",
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.formatString(
                      _vm.tradingProductGroupSummary.loanIds.length,
                      "n0"
                    )
                  ) +
                  " " +
                  _vm._s(
                    _vm.pluralize(
                      _vm.tradingProductGroupSummary.loanIds.length,
                      "Loans",
                      "Loan"
                    )
                  ) +
                  " in Trading Product Group\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c("full-screen-toggle", {
            ref: "wrapper",
            staticClass: "flex-grow flex flex-col px-3 pr-4 pb-3",
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (fullScreenSlotProps) {
                    return [
                      _c("ls-grid", {
                        staticClass: "w-full flex-grow",
                        attrs: {
                          "defaults-key": "trading-info-side-drawer",
                          views: "",
                          "summary-mode": "",
                          "auto-load": "",
                          filters: "",
                          groups: "",
                          "column-filters": "",
                          "as-of-date": "",
                          "export-to-excel": "",
                          "cut-copy-paste": "",
                          partitions: "",
                          expand: "",
                          "adhoc-key-set":
                            _vm.tradingProductGroupSummary.loanIds.length === 0
                              ? ["-1"]
                              : _vm.tradingProductGroupSummary.loanIds.map(
                                  (x) => x.toString()
                                ),
                        },
                        on: {
                          fullscreen: function ($event) {
                            return fullScreenSlotProps.onFullScreenToggle()
                          },
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              3849539239
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }